import '../select/gb-select.tag.html';
import { Filter } from './gb-filter';
riot.tag2('gb-filter', '<yield> <gb-select scope="gb-filter"> </gb-select> </yield>', '', '', function(opts) {
    this._mixin(Filter);
});



/** WEBPACK FOOTER **
 ** ./src/tags/filter/gb-filter.tag.html
 **/